const serverUrlImages = process.env.REACT_APP_SERVER_URL_IMAGES;

export const companyMembers = [
	{
		fullname: 'Dr. Andrés Simón González-Silén',
		position: 'Executive Chairman',
		// otherPosition: 'Presidente Ejecutivo',
		photo: `${serverUrlImages}/about-as/AndresSimon.png`,
		alt: 'Foto del Doctor Andrés Simón González Silén',
		linkedin: 'https://www.linkedin.com/in/andres-simon-gonzalez-silen/'
	},
	{
		fullname: 'Armando Baquero Ponte',
		position: 'Chief Executive Officer',
		otherPosition: 'CEO',
		photo: `${serverUrlImages}/about-as/ArmandoVaquero.png`,
		alt: 'Foto de Armando Baquero',
		linkedin: 'https://www.linkedin.com/in/armando-baquero-ponte/'
	},
	{
		fullname: 'Dr. Luis E. Velásquez Díaz',
		position: 'Chief Operations Officer',
		otherPosition: 'COO',
		photo: `${serverUrlImages}/about-as/Luis.png`,
		alt: 'Foto del Doctor Luis Velásquez',
		linkedin: 'https://www.linkedin.com/in/luis-enrique-velasquez-8a1302194/'
	},
	{
		fullname: 'María Ortiz',
		position: 'Chief Product & Technology Officer',
		otherPosition: 'CP&TO',
		photo: `${serverUrlImages}/about-as/Maria.png`,
		alt: 'Foto de María Ortiz',
		linkedin: 'https://www.linkedin.com/in/maria-ortiz-uber/'
	},
	{
		fullname: 'Miguel Medina',
		position: 'Country Director Mexico',
		photo: `${serverUrlImages}/about-as/MiguelMedina.png`,
		alt: 'Foto de Miguel Medina',
		linkedin: 'https://www.linkedin.com/in/likemikemedina/'
	},
	{
		fullname: 'Alejandra Orsini',
		position: 'Country Director Dominican Republic',
		photo: `${serverUrlImages}/about-as/Alejandra.png`,
		alt: 'Foto de Alejandra Orsini',
		linkedin:
			'https://www.linkedin.com/in/alejandra-denise-orsini-santana-08787a65/'
	},
	{
		fullname: 'Bjorn Pardo',
		position: 'Country Director Philippines',
		photo: `${serverUrlImages}/about-as/Bjorn.png`,
		alt: 'Foto de Bjorn Pardo',
		linkedin: 'https://www.linkedin.com/in/bjornpardo/'
	},
	{
		fullname: 'Andoni Alava Zubizarreta',
		position: 'Country Director Venezuela',
		photo: `${serverUrlImages}/about-as/Andoni.png`,
		alt: 'Foto de Andoni Alava Zubizarreta',
		linkedin: 'https://www.linkedin.com/in/andoni-alava-zubizarreta-971bb734/'
	},
	{
		fullname: 'Cecilia Toscana Rodríguez',
		position: 'Country Director Central America',
		photo: `${serverUrlImages}/about-as/Cecilia.png`,
		alt: 'Foto de Cecilia Toscana Rodríguez',
		linkedin: 'https://www.linkedin.com/in/ceciliatoscana/'
	},
	{
		fullname: 'Leyre Pérez San José',
		position: 'Head of Growth',
		photo: `${serverUrlImages}/about-as/Leyre.png`,
		alt: 'Foto de Leyre Pérez San José',
		linkedin: 'https://www.linkedin.com/in/leyreperez/'
	},
	{
		fullname: 'Carlos Torres Costales',
		position: 'Chief Financial Officer',
		otherPosition: 'CFO',
		photo: `${serverUrlImages}/about-as/Carlos.png`,
		alt: 'Foto de Carlos Torres Costales',
		linkedin: 'https://www.linkedin.com/in/carlostorrescostales/'
	},
	{
		fullname: 'Gaspar de Osma',
		position: 'Head of Strategy and Business Development',
		photo: `${serverUrlImages}/about-as/Gaspar.png`,
		alt: 'Foto de Gaspar de Osma',
		linkedin: 'https://www.linkedin.com/in/gaspar-de-osma-326545a3/'
	},
	{
		fullname: 'Begoña Rodríguez',
		position: 'Legal Director',
		photo: `${serverUrlImages}/about-as/Begona.png`,
		alt: 'Foto de Begoña Rodríguez',
		linkedin: 'https://www.linkedin.com/in/begoña-rodríguez-olazábal-383b617b/'
	},
	{
		fullname: 'Rodrigo Zapata',
		position: 'Global Commercial Director',
		linkedin: 'https://www.linkedin.com/in/rodrigozapatap/',
		alt: 'Foto de Rodrigo Zapata',
		photo: `${serverUrlImages}/about-as/RodrigoZapata.png`
	}
];
